import { type Institution } from '../../../services/institutions';
import { getInstitution } from '../../../features/institution/institution.selectors';
import { useSelector } from 'react-redux';

type UseCurrentInstitutionReturnType = {
  institution: Institution | null;
};

export const useCurrentInstitution = (): UseCurrentInstitutionReturnType => {
  const institution = useSelector(getInstitution) ?? null;

  return {
    institution,
  };
};
